/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EListSearchType {
    Equals = 'Equals',
    NotEquals = 'NotEquals',
    NestedDefault = 'NestedDefault'
}


export function EListSearchTypeFromJSON(json: any): EListSearchType {
    return EListSearchTypeFromJSONTyped(json, false);
}

export function EListSearchTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchType {
    return json as EListSearchType;
}

export function EListSearchTypeToJSON(value?: EListSearchType | null): any {
    return value as any;
}

